import { ExecuteAPIPost } from '../server-utils'
import { EndPoints } from '../endpoints'
import { CoinBaseViewModel } from '../../models/coin-base-models'

export const CoinBaseUtils = {
  createCoinBaseCharge: async function createCoinBaseCharge(coinBase: CoinBaseViewModel) {
    return await ExecuteAPIPost<any>(EndPoints.CoinBase.CreateCoinBaseCharge, coinBase)
  }
}
